import React, { useRef, useEffect } from "react";
import _ from "lodash";
import cx from "classnames";
import { connect } from "react-redux";
import { motion } from "framer-motion/dist/framer-motion";
import { AnimatePresence } from "framer-motion/dist/framer-motion";

import Socket from "socket";
import { logoVariants } from "shared/components/animations";
import AllModal from "./components/AllModal";
import AllStart from "./components/AllStart";
import LiarGuessing from "./components/LiarGuessing";
import OverComponent from "./components/OverComponent";
import GuesserGuessing from "./components/GuesserGuessing";
import * as sbsAction from "redux/sbs/action";
import logo from "assets/images/ttl/ttl-logo.png";

const TTL = (props) => {
  const gameReducer = _.get(props, "gameReducer");
  const sbsReducer = _.get(props, "sbsReducer");
  const mobile_app = _.get(gameReducer, "mobile_app");
  const currentUser = _.get(gameReducer, "currentUser");
  const ttl_modal_open = _.get(sbsReducer, "ttl_modal_open");
  const ttl_lie = _.get(sbsReducer, "ttl_lie");
  const ttl_truths = _.get(sbsReducer, "ttl_truths");
  const ttl_guesser = _.get(sbsReducer, "ttl_guesser");
  const ttl_users_list = _.get(sbsReducer, "ttl_users_list");
  const ttl_user_score = _.get(sbsReducer, "ttl_user_score");
  const ttl_players_array = _.get(sbsReducer, "ttl_players_array");
  const set_ttl_lie = _.get(props, "set_ttl_lie");
  const set_ttl_truths = _.get(props, "set_ttl_truths");
  const set_ttl_guesser = _.get(props, "set_ttl_guesser");
  const set_ttl_modal_open = _.get(props, "set_ttl_modal_open");
  const set_ttl_users_list = _.get(props, "set_ttl_users_list");
  const set_ttl_user_score = _.get(props, "set_ttl_user_score");
  const set_ttl_players_array = _.get(props, "set_ttl_players_array");
  const roomObj = _.get(gameReducer, "roomObj");
  const users = _.get(roomObj, "users");
  const game_state = _.get(roomObj, "game_state");
  const status = _.get(game_state, "status");
  const current_round = _.get(game_state, "current_round");
  const current_submission = _.get(game_state, "current_submission");
  const correct_answer = _.get(current_submission, "correct_answer");
  const player_guesses = _.get(game_state, "player_guesses");
  const player_scores = _.get(game_state, "player_scores");
  const answers = _.get(current_submission, "answers");
  const asker_id = _.get(game_state, "asker");

  const chooseasker_params = _.get(
    props,
    "paramsReducer.gameObj.0_chooseasker"
  );
  const guessing_params = _.get(props, "paramsReducer.gameObj.1_guessing");
  const over_params = _.get(props, "paramsReducer.gameObj.2_over");
  const chooseasker_modal_title = _.get(
    chooseasker_params,
    "modal_title",
    "The Host is picking The Player"
  );
  const guessing_modal_title = _.get(
    guessing_params,
    "modal_title",
    "The Player has been chosen!"
  );
  const over_modal_title = _.get(
    over_params,
    "modal_title",
    "The round has ended!"
  );

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser.userId
  );
  const isAsker = currentPlayer?.player_id === asker_id;
  const asker = users?.find((user) => user.player_id === asker_id);
  const firstUpdate = useRef(true);

  const toggleModal = () => {
    set_ttl_modal_open(!ttl_modal_open);
  };

  useEffect(() => {
    if (isAsker) {
      if (status === "Over") {
        set_ttl_lie("");
        set_ttl_truths(["", ""]);
      }
    }
  }, [status]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    set_ttl_guesser({
      clicked: false,
      confirmed: false,
      guessed: null
    });
    set_ttl_users_list({
      lie: [],
      truth_1: [],
      truth_2: []
    });
    set_ttl_modal_open(false);
  }, [current_round]);

  useEffect(() => {
    if (status === "Guessing") {
      let lie_array = [];
      let truth_1_array = [];
      let truth_2_array = [];
      for (const player of player_guesses) {
        const user_image = users?.find(
          (user) => user.player_id === player.player_id
        )?.profile_image;

        if (player.guess === correct_answer) {
          lie_array = [...lie_array, { ...player, profile_image: user_image }];
        } else {
          if (ttl_truths[0] === answers[player.guess]) {
            truth_1_array = [
              ...truth_1_array,
              { ...player, profile_image: user_image }
            ];
          } else {
            truth_2_array = [
              ...truth_2_array,
              { ...player, profile_image: user_image }
            ];
          }
        }
      }

      set_ttl_users_list({
        ...ttl_users_list,
        lie: lie_array,
        truth_1: truth_1_array,
        truth_2: truth_2_array
      });
    }
  }, [status, player_guesses]);

  const handleAnswerClick = (guess) => {
    set_ttl_guesser({ ...ttl_guesser, clicked: true, guessed: guess });
  };

  const handleBack = () => {
    set_ttl_guesser({ ...ttl_guesser, clicked: false });
  };

  const handleConfirm = () => {
    set_ttl_guesser({ ...ttl_guesser, confirmed: true });
    if (mobile_app) {
      const message = {
        action: "ttl-vote",
        guess: ttl_guesser.guessed
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "ttl-vote",
        roomId: roomObj?.id,
        playerId: currentPlayer.player_id,
        guess: ttl_guesser.guessed
      };
      Socket.sendMessage(data);
    }
  };

  useEffect(() => {
    if (status === "Over") {
      let usersArray = [];
      let scores_array = [...player_scores];
      scores_array.sort((a, b) =>
        a.player_id > b.player_id ? 1 : b.player_id > a.player_id ? -1 : 0
      );

      for (let i = 0; i < users.length; i++) {
        usersArray = [
          ...usersArray,
          {
            ...scores_array[i],
            display_name: users[i].display_name,
            profile_image: users[i].profile_image
          }
        ];
      }
      usersArray?.sort((a, b) =>
        a?.score < b?.score ? 1 : b?.score < a?.score ? -1 : 0
      );
      for (let i = 0; i < usersArray.length; i++) {
        if (i === 0) {
          usersArray[i].rank = 1;
        } else {
          if (usersArray[i].score === usersArray[i - 1].score) {
            usersArray[i].rank = usersArray[i - 1].rank;
          } else {
            usersArray[i].rank = i + 1;
          }
        }
      }
      set_ttl_players_array(usersArray);
    }
  }, [status, player_scores]);

  useEffect(() => {
    if (status === "Over") {
      let guessed_lie = 0;
      let score = null;
      if (isAsker) {
        for (const player of player_guesses) {
          if (player.guess !== correct_answer) {
            guessed_lie += 1;
          }
        }
        if (_.isEmpty(player_guesses)) {
          score = 0;
        } else if (guessed_lie === player_guesses.length) {
          score = 300;
        } else if (guessed_lie >= Math.ceil(player_guesses.length / 2)) {
          score = 200;
        } else {
          score = 0;
        }
      } else {
        if (ttl_guesser.guessed === correct_answer) {
          score = 100;
        } else {
          score = 0;
        }
      }
      score !== null && set_ttl_user_score(score);
    }
  }, [status, player_guesses]);

  return (
    <div className="smallbites heightFull">
      <div
        className={cx("bingo-content-wrapper", {
          "playing-overflow-scroll": status === "Playing"
        })}
      >
        <div className="ttl-wrapper">
          <AnimatePresence exitBeforeEnter>
            <motion.div
              key="ttl_1"
              variants={logoVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="ttl-logo"
            >
              <img src={logo} alt="logo" />
            </motion.div>
          </AnimatePresence>
          <div className="ttl-main-wrapper">
            <AnimatePresence exitBeforeEnter>
              {status === "ChooseAsker" &&
                (!ttl_modal_open ? (
                  <AllStart
                    key="ttl_2"
                    mobile_app={mobile_app}
                    toggleModal={toggleModal}
                    chooseasker_params={chooseasker_params}
                  />
                ) : (
                  <AllModal
                    key="ttl_3"
                    ttl_lie={ttl_lie}
                    roomId={roomObj?.id}
                    mobile_app={mobile_app}
                    ttl_truths={ttl_truths}
                    toggleModal={toggleModal}
                    set_ttl_lie={set_ttl_lie}
                    set_ttl_truths={set_ttl_truths}
                    playerId={currentPlayer?.player_id}
                    modal_title={chooseasker_modal_title}
                  />
                ))}
              {status === "Guessing" &&
                (isAsker ? (
                  <LiarGuessing
                    key="ttl_4"
                    users={users}
                    ttl_lie={ttl_lie}
                    mobile_app={mobile_app}
                    ttl_truths={ttl_truths}
                    ttl_users_list={ttl_users_list}
                    guessing_params={guessing_params}
                  />
                ) : ttl_modal_open ? (
                  <AllModal
                    key="ttl_5"
                    ttl_lie={ttl_lie}
                    roomId={roomObj?.id}
                    mobile_app={mobile_app}
                    ttl_truths={ttl_truths}
                    toggleModal={toggleModal}
                    set_ttl_lie={set_ttl_lie}
                    set_ttl_truths={set_ttl_truths}
                    playerId={currentPlayer?.player_id}
                    modal_title={guessing_modal_title}
                  />
                ) : (
                  <GuesserGuessing
                    key="ttl_6"
                    asker={asker}
                    answers={answers}
                    onBack={handleBack}
                    mobile_app={mobile_app}
                    onConfirm={handleConfirm}
                    toggleModal={toggleModal}
                    ttl_guesser={ttl_guesser}
                    onAnswerClick={handleAnswerClick}
                    guessing_params={guessing_params}
                  />
                ))}
              {status === "Over" &&
                (isAsker ? (
                  <OverComponent
                    key="ttl_7"
                    users={users}
                    answers={answers}
                    isAsker={isAsker}
                    mobile_app={mobile_app}
                    over_params={over_params}
                    toggleModal={toggleModal}
                    currentPlayer={currentPlayer}
                    ttl_users_list={ttl_users_list}
                    correct_answer={correct_answer}
                    ttl_user_score={ttl_user_score}
                    ttl_players_array={ttl_players_array}
                    guesserGuessed={ttl_guesser?.guessed}
                  />
                ) : ttl_modal_open ? (
                  <AllModal
                    key="ttl_8"
                    ttl_lie={ttl_lie}
                    roomId={roomObj?.id}
                    mobile_app={mobile_app}
                    ttl_truths={ttl_truths}
                    toggleModal={toggleModal}
                    set_ttl_lie={set_ttl_lie}
                    modal_title={over_modal_title}
                    set_ttl_truths={set_ttl_truths}
                    playerId={currentPlayer.player_id}
                  />
                ) : (
                  <OverComponent
                    key="ttl_9"
                    answers={answers}
                    isAsker={isAsker}
                    mobile_app={mobile_app}
                    over_params={over_params}
                    toggleModal={toggleModal}
                    currentPlayer={currentPlayer}
                    correct_answer={correct_answer}
                    ttl_user_score={ttl_user_score}
                    ttl_players_array={ttl_players_array}
                    guesserGuessed={ttl_guesser?.guessed}
                  />
                ))}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sbsReducer: state.sbsReducer,
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => ({
  set_ttl_lie: (data) => dispatch(sbsAction.set_ttl_lie(data)),
  set_ttl_truths: (data) => dispatch(sbsAction.set_ttl_truths(data)),
  set_ttl_guesser: (data) => dispatch(sbsAction.set_ttl_guesser(data)),
  set_ttl_modal_open: (data) => dispatch(sbsAction.set_ttl_modal_open(data)),
  set_ttl_users_list: (data) => dispatch(sbsAction.set_ttl_users_list(data)),
  set_ttl_user_score: (data) => dispatch(sbsAction.set_ttl_user_score(data)),
  set_ttl_players_array: (data) =>
    dispatch(sbsAction.set_ttl_players_array(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(TTL);
